import { QueryClient } from '@tanstack/react-query';

/**
 * App-wide React Query client. Exported as a module singleton so
 * non-component code (e.g. the demo cross-tab prospect sync) can
 * invalidate caches without threading the client through props.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});
